import { Component, HostBinding, Input } from "@angular/core";
import { ApiMembershipProductFeature } from "@tytapp/api";

@Component({
    selector: 'tyt-membership-feature',
    templateUrl: './membership-feature.component.html',
    styleUrls: ['./membership-feature.component.scss']
})
export class MembershipFeatureComponent {
    @Input()
    feature : ApiMembershipProductFeature;

    @HostBinding('style.background-image')
    get backgroundImageUrl() {
        if (!this.feature)
            return null;

        return `url(${this.feature.feature_image_url})`;
    }
}